import React from 'react';
import styled from 'styled-components';
import { FaInstagram, FaLinkedin, FaFacebook } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.surfaceAlt};
  color: ${props => props.theme.colors.text};
  padding: 2rem;
  margin-top: 4rem;
  border-top: 1px solid ${props => props.theme.colors.border};
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
`;

const Logo = styled.h3`
  font-family: 'Georgia', serif;
  color: ${props => props.theme.colors.primary};
  font-size: 1.8rem;
  margin: 0;
  font-weight: 700;
`;

const Tagline = styled.p`
  color: ${props => props.theme.colors.textSecondary};
  font-size: 0.95rem;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const SocialLink = styled.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  transition: color 0.3s ease;
  color: ${props => props.$color || props.theme.colors.text};
  
  &:hover {
    color: ${props => props.$hoverColor || props.theme.colors.primary};
  }
`;

const Copyright = styled.p`
  color: ${props => props.theme.colors.textTertiary};
  font-size: 0.85rem;
  margin: 0;
  padding-top: 0.5rem;
  border-top: 1px solid ${props => props.theme.colors.border};
  width: 100%;
  text-align: center;
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <Logo>Hustling</Logo>
        <Tagline>
          Built by hustlers, for hustlers. Join our community:
        </Tagline>
        <Tagline style={{ gap: '1rem' }}>
          <SocialLink 
            href="https://www.instagram.com/hustling.sa/?hl=en" 
            target="_blank" 
            rel="noopener noreferrer"
            $color="#E1306C"
            $hoverColor="#F56040"
          >
            Instagram <FaInstagram />
          </SocialLink>
          <SocialLink 
            href="https://www.linkedin.com/company/hustling/" 
            target="_blank" 
            rel="noopener noreferrer"
            $color="#0A66C2"
            $hoverColor="#004182"
          >
            LinkedIn <FaLinkedin />
          </SocialLink>
          <SocialLink 
            href="https://www.facebook.com/share/1A2D8m3DRi/" 
            target="_blank" 
            rel="noopener noreferrer"
            $color="#1877F2"
            $hoverColor="#0C63D4"
          >
            Facebook <FaFacebook />
          </SocialLink>
        </Tagline>
        <Copyright>© 2025 Hustling — All rights reserved</Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
